import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-p-6 tw-text-left" }
const _hoisted_2 = { class: "tw-max-w-xl" }
const _hoisted_3 = { class: "tw-mt-6 tw-grid tw-grid-cols-1 tw-gap-6" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "tw-flex tw-justify-start" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "tw-text-lg tw-font-medium tw-text-slate-900" }, "Container Refresh Frequency", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "tw-mt-1 tw-text-sm tw-text-slate-500" }, " Set how often your containers should be automatically updated when they are not in the \"Urgent\" window. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            for: "interval",
            class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700"
          }, " Refresh Interval ", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "interval",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedInterval) = $event)),
            class: "tw-mt-2 tw-block tw-w-full tw-rounded-lg tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-slate-900 tw-shadow-sm focus:tw-border-indigo-500 focus:tw-ring-indigo-500 sm:tw-text-sm"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervalOptions, (opt) => {
              return (_openBlock(), _createElementBlock("option", {
                key: opt.value,
                value: opt.value
              }, _toDisplayString(opt.label), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedInterval]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "tw-mt-3 tw-text-xs tw-text-slate-400" }, " * Note: Containers with ETA ≤ 24h will still be updated every 1 hour for safety. ", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args))),
            disabled: _ctx.saving,
            class: "tw-inline-flex tw-justify-center tw-rounded-lg tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-slate-800 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-400 disabled:tw-opacity-50"
          }, _toDisplayString(_ctx.saving ? 'Saving...' : 'Save Settings'), 9, _hoisted_6)
        ])
      ])
    ])
  ]))
}